/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useIsPath } from '~src/hooks/useIsPath';
import MyTendersBreadcrumbs from './components/MyTendersBreadcrumbs';
import DefaultBreadcrumbs from './components/DefaultBreadcrumbs';
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { NavItemType } from '~src/data/navigationItems';

export interface StateBreadCrumb {
  name?: string;
  path: string;
  /** for first level items e.g. archive, recent */
  navItem?: Partial<NavItemType>;
  disabled?: boolean;
  iconKey?: string;
}

export const homeNavItem = {
  icon: ['fad', 'house'] as [IconPrefix, IconName],
  color: 'darkGray',
};

const Breadcrumbs = () => {
  const isOnMyTenders = useIsPath('my-tenders');

  if (isOnMyTenders) return <MyTendersBreadcrumbs />;
  return <DefaultBreadcrumbs />;
};

export default Breadcrumbs;
